// Shared hook to exit the admin "view client side" mode and restore the
// admin's own session. Used by both the banner and the client navbar.

import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useExitClientViewMutation } from "../services/api";
import { setCredentials, clearViewAs } from "../store/slices/authSlice";

export default function useExitClientView() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [exitClientView, { isLoading }] = useExitClientViewMutation();

  const exit = useCallback(async () => {
    try {
      const res = await exitClientView().unwrap();
      dispatch(setCredentials(res));
      dispatch(clearViewAs());
      navigate("/admin/dashboard");
    } catch (err) {
      console.error("Failed to exit client view:", err);
      // Even if the server call fails, drop the local view-as flag so the
      // admin isn't stuck on the client side.
      dispatch(clearViewAs());
      navigate("/admin/dashboard");
    }
  }, [exitClientView, dispatch, navigate]);

  return { exit, isExiting: isLoading };
}
